<template>
  <div id="app">

    <div class="container-fluid">
      <div class="row justify-content-center bg-dark">
        <div class="col width-1140 ie-flex-col">
          <top-menu class="text-regular"></top-menu>
        </div>
      </div>
    </div>

    <div class="container main-contain-reg">
      <div class="row justify-content-center main-contain-inner">
        <div class="col bg-light">
          <router-view />
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row justify-content-center footer-container bg-dark text-light">
        <div class="col width-1140 ie-flex-col">
          <footer-menu class="text-regular"></footer-menu>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>

import TopMenu from '@/components/menu/TopMenu.vue'
import FooterMenu from '@/components/menu/FooterMenu.vue'

export default {
  components: {
    TopMenu,
    FooterMenu
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style>

.link-button {
  padding: 8px;
}

.width-1140 {
  width: 100%;
  max-width: 1140px;
}

.main-contain-reg > div {
  min-height: 900px;
  padding-top: 0px;
}

.main-contain-inner {
  margin-bottom: 24px;
}

.footer-container a {
  color: #ffffff;
}

.button-hover {
  cursor: pointer;
}
</style>
